/**
 * Shared book lookup — resolves ?book=<param> against bookExamples.js
 * accepting EITHER a numeric id OR a kebab-case slug of the title.
 *
 * Used by BodhaPage, SankalpaPage, and any future stage that needs to
 * hydrate a book snapshot from the URL.
 */

import { bookExamples } from "../data/bookExamples";

export function toSlug(str) {
  return String(str || "")
    .toLowerCase()
    .replace(/'/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Drop a leading article ("the-", "a-", "an-") so book slugs that strip
// articles server-side (e.g. "psychology-of-money") still match a title
// slug that keeps them ("the-psychology-of-money").
function stripLeadingArticle(slug) {
  return String(slug || "").replace(/^(the|a|an)-/, "");
}

export function resolveBook(param) {
  if (!param) return null;
  const asNum = Number(param);
  if (!Number.isNaN(asNum)) {
    const byId = bookExamples.find((b) => b.id === asNum);
    if (byId) return byId;
  }
  const slug = toSlug(param);
  const bare = stripLeadingArticle(slug);
  return (
    bookExamples.find((b) => {
      const t = toSlug(b.title);
      return t === slug || stripLeadingArticle(t) === bare;
    }) || null
  );
}
